import React, { useRef } from "react";
import "../Styles/SpecialistScroller.css";
import arrowLeft from "../Images/ArrowLeft.png";
import arrowRight from "../Images/ArrowRight.png";
import SpecialistCard from "./SpecialistCard";
import doctors from "../contents/doctors";

const SpecialistScroller = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        // left: direction === "left" ? -300 : 300,
        left:
          direction === "left"
            ? -scrollRef.current.clientWidth
            : scrollRef.current.clientWidth,

        behavior: "smooth",
      });
    }
  };

  return (
    <div className="specialist-section">
      <h2>
        Meet Our <span>Specialists</span>
      </h2>
      <p>
        We use only the best quality materials on the market in order to provide
        the best products to our patients.
      </p>

      <div
        className={`specialist-carousel ${
          doctors.length <= 2 ? "centered" : ""
        }`}
        ref={scrollRef}
      >
        {doctors.map((doc, index) => (
          <SpecialistCard
            key={index}
            name={doc.name}
            specialty={doc.specialty}
            image={doc.image}
            linkedin={doc.linkedin}
          />
        ))}
      </div>

      <div className="specialist-controls">
        <button onClick={() => scroll("left")}>
          <img src={arrowLeft} alt="Left Arrow" />
        </button>
        <button onClick={() => scroll("right")}>
          <img src={arrowRight} alt="Right Arrow" />
        </button>
      </div>
    </div>
  );
};

export default SpecialistScroller;
